import { helper } from '@ember/component/helper';
import { customFieldLayout as customFieldLayout$1 } from '../lib/custom-field-layout.js';

/**
 * MAP (in-file navigation graph — keep in sync with code):
 *   role:      helper — `(custom-field-layout fields)` → { entries, empty } for a read-only custom-field list
 *              (filled fields, prefix groups, empty fields apart); thin wrapper, logic in lib/custom-field-layout.js
 *   used by:   beebee-scuola-sci-base-segreteria scuolasci-contact-detail-nuova.hbs (UI nuova customer record)
 *   tests:     tests/unit/lib/custom-field-layout-test.js (the pure function)
 */
var customFieldLayout = helper(function customFieldLayoutHelper([fields]) {
  return customFieldLayout$1(fields);
});

export { customFieldLayout as default };
//# sourceMappingURL=custom-field-layout.js.map
